require("./bootstrap");
import route from '../../vendor/tightenco/ziggy/src/js/index';
import Vue from "vue";
import vSelect from "vue-select";



window.Vue = Vue;

window.Bus = new Vue();

Vue.prototype.locale = window._locale;

Vue.prototype.__ = (key) => {
  return window._translations[window._locale][key]
    ? window._translations[window._locale][key]
    : key;
};

Vue.prototype.$super = function(options) {
  return new Proxy(options, {
    get: (options, name) => {
      if (options.methods && name in options.methods) {
        return options.methods[name].bind(this);
      }
    },
  });
};
Vue.mixin({
  methods: {
    route,
    localeRoute(name, params, absolute, config) {
      name = `${this.locale}.${name}`;
      return route(name, params, absolute, config);
    },
  },
});

Vue.component("products-grid", () =>
  import(
    /* webpackChunkName: "products-grid" */ "@front/shared/ProductsDisplay.vue"
    ),
);
Vue.component("select-field", () =>
  import(
    /* webpackChunkName: "select-field" */ "@front/forms/SelectField.vue"
    ),
);
Vue.component("quick-view-sidebar", () =>
  import(
    /* webpackChunkName: "quick-view-sidebar" */ "@front/products/QuickViewSidebar.vue"
    ),
);
Vue.component("product-details-sidebar", () =>
  import(
    /* webpackChunkName: "product-details-sidebar" */ "@front/products/ProductDetailsSidebar.vue"
    ),
);
Vue.component("product-page-details", () =>
  import(
    /* webpackChunkName: "product-page-details" */ "@front/products/ProductPageDetails.vue"
    ),
);
Vue.component("product-card", () =>
  import(
    /* webpackChunkName: "products-section" */ "@front/shared/ProductCard.vue"
    ),
);
Vue.component("products-section", () =>
  import(
    /* webpackChunkName: "products-section" */ "@front/shared/ProductsSection.vue"
    ),
);
Vue.component("toggle-favorite-product", () =>
  import(
    /* webpackChunkName: "toggle-favorite-product" */ "@front/products/ToggleFavoriteProduct.vue"
    ),
);
Vue.component("search-toggle-button", () =>
  import(
    /* webpackChunkName: "search-toggle-button" */ "@front/search/SearchToggleButton.vue"
    ),
);

Vue.component("search-sidebar-wrapper", () =>
  import(
    /* webpackChunkName: "search-sidebar-wrapper" */ "@front/search/SearchSidebarWrapper.vue"
    ),
);

Vue.component("profile-sidebar-button", () =>
  import(
    /* webpackChunkName: "profile-sidebar-button" */ "@front/profile/ProfileSidebarButton.vue"
    ),
);

Vue.component("profile-sidebar-wrapper", () =>
  import(
    /* webpackChunkName: "profile-sidebar-wrapper" */ "@front/profile/ProfileSidebarWrapper.vue"
    ),
);

Vue.component("cart-toggle-button", () =>
  import(
    /* webpackChunkName: "cart-toggle-button" */ "@front/cart/CartToggleButton.vue"
    ),
);
Vue.component("checkout-page", () =>
  import(
    /* webpackChunkName: "checkout-page" */ "@front/checkout/CheckoutPage.vue"
    ),
);
Vue.component("guest-user-info", () =>
  import(
    /* webpackChunkName: "guest-user-infoe" */ "@front/checkout/GuestUserInfo.vue"
    ),
);
Vue.component("profile-page", () =>
  import(
    /* webpackChunkName: "profile-page" */ "@front/profile/ProfilePage.vue"
    ),
);

Vue.component("my-slider", () =>
  import(
    /* webpackChunkName: "my-slider" */ "@front/sliders/Slider.vue"
    ),
);
Vue.component("home-page-slider", () =>
  import(
    /* webpackChunkName: "home-page-slider" */ "@front/sliders/HomePageSlider.vue"
    ),
);

Vue.component("mobile-menu", () =>
  import(
    /* webpackChunkName: "mobile-menu" */ "@front/menu/MobileMenu.vue"
    ),
);

Vue.component("read-more-paragraph", () =>
  import(
    /* webpackChunkName: "read-more-paragraph" */ "@front/shared/ReadMoreParagraph.vue"
    ),
);
Vue.component("filters", () =>
  import(
    /* webpackChunkName: "filters" */ "@front/shared/Filters.vue"
    ),
);

Vue.component("locations-display", () =>
  import(
    /* webpackChunkName: "locations-display" */ "@front/components/LocationsDisplay.vue"
    ),
);

Vue.component("stores-sidebar-button", () =>
  import(
    /* webpackChunkName: "stores-sidebar-button" */ "@front/stores/StoresSidebarButton.vue"
    ),
);

Vue.component("stores-sidebar-wrapper", () =>
  import(
    /* webpackChunkName: "store-sidebar" */ "@front/stores/StoresSidebarWrapper.vue"
    ),
);

Vue.component("phone-number", () =>
  import(
    /* webpackChunkName: "phone-number" */ "@front/shared/PhoneNumber.vue"
    ),
);

Vue.component("price-display", () =>
  import(
    /* webpackChunkName: "price-display" */ "@front/shared/PriceDisplay.vue"
    ),
);

Vue.component("v-select", vSelect);


const app = new Vue({
  el: "#app",
  mounted() {
    window.addEventListener("resize", () => {
      Bus.$emit("window-resized");
    });
  },
});
